export default __webpack_public_path__ + "static/161-a16b2177417c0bb3c724726c9e6efa91.mp4";